import React from 'react';
import { useLocation } from 'react-router-dom';
import CareersFooter from '../components/CareersComponents/CareersFooter';
import RecentBlogPosts from '../components/Common/RecentBlogPosts';
import TeamActivityHero from '../components/CareersComponents/TeamActivityComponents/TeamActivityHero';
import AllBlogPosts from '../components/CareersComponents/TeamActivityComponents/AllBlogPosts';
import { useTeamActivity } from '../hooks/useTeamActivity';

const TeamActivity = () => {
  const location = useLocation();
  
  // Get initial page from location state if user came back from activity details
  const initialPage = location.state?.initialPage || 1;
  
  // Fetch team activity data from API
  const { teamActivityPosts, loading, error } = useTeamActivity(1, 1);

  return (
    <>
      <TeamActivityHero />
      <RecentBlogPosts 
        blogPosts={teamActivityPosts} 
        title="Latest Team Activity Updates" 
        fromWhere='team_activity'
        loading={loading}
        error={error}
        maxPosts={3}
      />
      <AllBlogPosts 
        blogPosts={teamActivityPosts}
        loading={loading}
        error={error}
        fromWhere="team_activity"
        initialPage={initialPage}
      />
      <CareersFooter />
    </>
  );
};

export default TeamActivity;
